import { withOverlayControls } from '@eventbrite/eds-structure';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import {
    GetEnrollmentStatus,
    useGetStatsigEnrollment,
} from '../../../../hooks';
import {
    DiscoverState,
    HeaderShape,
    LocationState,
    SearchBoxAndLocationPillExperiment,
    SearchBoxAndLocationPillValues,
    UserShape,
} from '../../../../types';
import { HeaderTitle } from '../../components/HeaderTitle';
import { SearchBar } from '../../components/SearchBar';
import { HomeEngagementExperimentTrackingLocations } from '../../constants/analytics';
import { clickCTASeasonal } from '../../redux/content/actions';
import { logToStatsigHomeEngagement } from '../../utils/analytics';
import { FullbleedHeaderBackgroundContainer } from '../FullbleedHeaderBackgroundContainer';
import './FullbleedHeader.scss';
interface FullbleedHeaderProps {
    location: LocationState;
    isLoading: boolean;
    history?: object;
    header: HeaderShape;
    clickCTASeasonal?: Function;
    user: UserShape;
    isMobile: boolean;
}

export const FullbleedHeader = ({
    header,
    clickCTASeasonal,
    user,
    isMobile,
}: FullbleedHeaderProps) => {
    const handleHeaderCTASeasonalClick = () => {
        logToStatsigHomeEngagement(
            HomeEngagementExperimentTrackingLocations.CITY_CTA,
            !!user.isAuthenticated,
        );
        clickCTASeasonal?.();
    };
    const homepageHeaderSearchExperiment = useGetStatsigEnrollment({
        name: SearchBoxAndLocationPillExperiment.name,
        paramName: SearchBoxAndLocationPillExperiment.paramName,
        defaultValue: null,
    });

    const parsedSearchHeaderVariant =
        homepageHeaderSearchExperiment.status === GetEnrollmentStatus.SUCCESS
            ? homepageHeaderSearchExperiment.variant
            : GetEnrollmentStatus.LOADING;

    let headerTitleComponent;

    if (parsedSearchHeaderVariant == GetEnrollmentStatus.LOADING) {
        headerTitleComponent = null;
    } else if (
        parsedSearchHeaderVariant == SearchBoxAndLocationPillValues.control
    ) {
        headerTitleComponent = <SearchBar />;
    } else {
        headerTitleComponent = (
            <HeaderTitle
                header={header}
                clickCTASeasonal={handleHeaderCTASeasonalClick}
                fullbleed={true}
            />
        );
    }

    const baseClassName =
        parsedSearchHeaderVariant === GetEnrollmentStatus.LOADING
            ? 'feed-loading-header'
            : parsedSearchHeaderVariant ===
              SearchBoxAndLocationPillValues.control
            ? 'feed-search-header'
            : 'feed-fullbleed-header';

    const header_section = baseClassName;
    const header_content = classNames({
        [`${baseClassName}__content`]: true,
    });

    return (
        <section className={header_section}>
            <div className="feed-fullbleed-header__wrapper">
                {parsedSearchHeaderVariant === GetEnrollmentStatus.LOADING ? (
                    <LoadingSkeleton
                        width="100%"
                        height={isMobile ? '146px' : '226px'}
                        borderRadius="2px"
                    />
                ) : parsedSearchHeaderVariant ===
                  SearchBoxAndLocationPillValues.control ? null : (
                    <FullbleedHeaderBackgroundContainer
                        type="MainHeaderBackground"
                        isSeasonal={header?.shouldShowCustomContent}
                        placeholder={header?.headerImagePlaceholder}
                    />
                )}

                <div className={header_content}>
                    <div className="eds-layout eds-layout--has-large-max-width eds-layout--has-horizontal-gutters">
                        <div className="eds-layout__body">
                            {headerTitleComponent}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const _mapStateToProps = ({ header, app, user, location }: DiscoverState) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
    user,
    location,
    isMobile: app.isMobile,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(FullbleedHeader),
);
